import numeral from "numeral";
import "numeral/locales/no";

numeral.locale("no");

const hasDecimals = (number?: number | string): boolean => parseFloat(`${number}`) !== parseInt(`${number}`);

export const getFormattedPrice = (price?: number | string): string => {
    let format = "0,0[.]00$";
    if (isNaN(parseFloat(`${price}`))) {
        throw new TypeError(`Price '${price}' is not a number`);
    }
    if (parseInt(`${price}`) < 10000) {
        format = "0[.]00$";
    }
    const currencySymbol = hasDecimals(price) ? "" : ",-";
    return numeral(price).format(format).replace("kr", currencySymbol);
};
